export default __webpack_public_path__ + "static/media/Radomir Tinkov - Gilroy-Black.6b911199.otf";